import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs';
import { showNotification } from '../helpers/show-toast';
import { of, throwError } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { baseUrl } from 'src/environments/environment';
import { RegisterLoginService } from './register-login.service';
@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService {
  private isRefreshing = false;

  constructor(
    private router: Router,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private authService: RegisterLoginService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authToken = localStorage.getItem('accessToken');

    let reqClone;

    let pattern = /^https?:\/\//g;

    if (authToken) {
      reqClone = this.addAccessTokenToHeader(req);
    } else {
      if (pattern.test(req?.url)) {
        reqClone = req.clone({ url: `${req.url}` });
      } else {
        reqClone = req.clone({ url: `${baseUrl}${req.url}` });
      }
    }

    this.spinner.show(undefined, {
      type: 'ball-scale-multiple',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.3)',
      color: '#fff'
    });
    return next.handle(reqClone).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse
          && !reqClone.url.toLowerCase().includes('login')
          && error.status === 401) {
          return this.handle401Error(req, next);
        } else if (error.status === 400 && !reqClone.url.toLowerCase().includes('refreshtoken')) {
          showNotification(
            'danger',
            `${error.error
              ? error?.error?.errorList[0]?.message
              : error?.errors?.tittle
            }`,
            this.toastr
          );
          this.spinner.hide();
        } else if (error.status == 0) {
          let MSG = '';
          if (error.error.errorList) {
            MSG = error?.error?.errorList[0]?.message
          } else if (error?.errors) {
            MSG = error?.errors?.tittle
          } else {
            MSG = 'unknown error'
          }
          showNotification(
            'danger',
            MSG,
            this.toastr
          );
        } else {
          showNotification(
            'danger',
            `Server Error: some thing went wrong!`,
            this.toastr
          );
        }
        return throwError(error.message);
      }),
      finalize(() => this.spinner.hide())
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      let tokenData = this.authService.getAccessAndRefreshToken();
      return this.authService.refreshToken(tokenData).pipe(
        switchMap((tokenDataResponse) => {
          this.isRefreshing = false;
          this.authService.setLoginResponseInLocalStorage(tokenDataResponse.data);
          return next.handle(this.addAccessTokenToHeader(request));
        }),
        catchError((error) => {
          this.isRefreshing = false;
          if (this.authService.getAccessAndRefreshToken().accessToken)
            localStorage.clear();
          this.router.navigateByUrl('auth/login');
          return throwError(() => error);
        })
      );
    }

    return next.handle(this.addAccessTokenToHeader(request));
  }

  private addAccessTokenToHeader(request: HttpRequest<any>) {
    let tokens = this.authService.getAccessAndRefreshToken();
    let reqClone;
    let pattern = /^https?:\/\//g;

    if (tokens.accessToken) {
      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + tokens.accessToken,
      });
      if (pattern.test(request?.url)) {
        reqClone = request.clone({ url: `${request.url}` });
      } else {
        reqClone = request.clone({ headers, url: `${baseUrl}${request.url}` });
      }
    }
    return reqClone;
  }
} 